import { useMediaQuery, useTheme } from '@material-ui/core';

export const useDeviceDetection = () => {
  const theme = useTheme();

  const isMobileDevice = useMediaQuery(theme.breakpoints.down('xs'), {
    noSsr: true
  });

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'), {
    noSsr: true
  });

  return {
    isMobileDevice,
    isSmallScreen
  };
};
